"use client";
import styled from "styled-components";

export const Styling = styled.div`
  position: absolute;
  left: 0;
  z-index: -1;

  width: 100%;
  overflow: hidden;
`;
